import React from "react";
import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { formatInteger, formatNumber } from "../networkReportFormatters";
import FactorClassificationBadge from "./FactorClassificationBadge";

const FactorRankingTable = ({ factors = [] }) => (
  <TableContainer>
    <Table>
      <Thead>
        <Tr>
          <Th>Rank</Th>
          <Th>Factor</Th>
          <Th>Factor category</Th>
          <Th>Stability</Th>
          <Th>Schools included</Th>
          <Th>Respondents</Th>
          <Th>Classification</Th>
        </Tr>
      </Thead>
      <Tbody>
        {factors.map((factor) => (
          <Tr key={factor.id}>
            <Td>{formatInteger(factor.rank)}</Td>
            <Td fontWeight="semibold">{factor.name}</Td>
            <Td>{factor.areaLabel}</Td>
            <Td>{formatNumber(factor.stabilityIndex)}</Td>
            <Td>{formatInteger(factor.organizationsIncluded)}</Td>
            <Td>{formatInteger(factor.respondents)}</Td>
            <Td><FactorClassificationBadge classification={factor.classification} /></Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  </TableContainer>
);

export default FactorRankingTable;
